import {
    FETCH_BTSWP,
    FETCH_BTSWP_START,
    FETCH_MORE,
    FAILED_BTSWP,
} from '../actions';

const initialState = {
    fetched: false,
    failed: false,
    btswp: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BTSWP_START:
            return { ...state, fetched: false, btswp: [] };
        case FETCH_BTSWP:
            return { ...state, fetched: true, btswp: action.payload };
        case FETCH_MORE:
            return { ...state, fetched: true, btswp: action.payload };
        case FAILED_BTSWP:
            return { ...state, failed: true };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/btswp_reducer.jsx